import { render, staticRenderFns } from "./FileSizeInput.vue?vue&type=template&id=935ced80&"
import script from "./FileSizeInput.vue?vue&type=script&lang=js&"
export * from "./FileSizeInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports